import { HttpClient } from '@adapters/HttpClient';
import { CrmStatusModel, ModifyOrderStatusRequest, CreateStatusRequest, UpdateStatusRequest } from '../models/CRM';

/**
 * Adaptador para la API de estados CRM.
 * GET /api/v1/crm/status - listado de estados
 * POST /api/v1/crm/status - crear estado
 * PUT /api/v1/crm/status/{statusId} - actualizar estado
 * DELETE /api/v1/crm/status/{statusId} - eliminar estado
 * POST /api/v1/crm/orders/status/modify - asignar o quitar estado de una orden
 */
export class CrmStatusApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getStatusList(): Promise<CrmStatusModel[]> {
    const response = await this.httpClient.get<{ data: CrmStatusModel[] }>(
      '/crm/status',
      {},
      {}
    );
    const data = response?.data;
    return Array.isArray(data) ? data : [];
  }

  async createStatus(data: CreateStatusRequest): Promise<{ id: number }> {
    const response = await this.httpClient.post<{ id: number }>(
      '/crm/status',
      {
        name: data.name,
        ...(data.color && { color: data.color }),
        ...(data.description && { description: data.description }),
        ...(data.priority !== undefined && { priority: data.priority }),
      }
    );
    return response ?? { id: 0 };
  }

  async updateStatus(statusId: number, data: UpdateStatusRequest): Promise<void> {
    await this.httpClient.put(`/crm/status/${statusId}`, {
      name: data.name,
      ...(data.color !== undefined && { color: data.color }),
      ...(data.description !== undefined && { description: data.description }),
      ...(data.priority !== undefined && { priority: data.priority }),
    });
  }

  async deleteStatus(statusId: number): Promise<void> {
    await this.httpClient.delete(`/crm/status/${statusId}`);
  }

  async modifyOrderStatus(data: ModifyOrderStatusRequest): Promise<void> {
    await this.httpClient.post('/crm/orders/status/modify', {
      order_id: data.order_id,
      crm_status_id: data.crm_status_id,
    });
  }
}
